module.exports = __webpack_public_path__ + "assets/img/faspay_818.8b0e181b.png";